/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ci_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can it help me find invisible or look-alike characters?`)
};

const es_ci_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puede ayudarme a encontrar caracteres invisibles o similares?`)
};

const de_ci_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann es mir helfen, unsichtbare oder ähnlich aussehende Zeichen zu finden?`)
};

const nl_ci_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan het me helpen onzichtbare of op elkaar lijkende karakters te vinden?`)
};

const fr_ci_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peut-il m'aider à trouver les caractères invisibles ou similaires ?`)
};

const it_ci_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi può aiutare a trovare caratteri invisibili o simili?`)
};

const pt_br2_ci_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pode me ajudar a encontrar caracteres invisíveis ou semelhantes?`)
};

const pt_ci_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pode ajudar-me a encontrar caracteres invisíveis ou semelhantes?`)
};

const ja_ci_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「見えない文字または類似文字を見つけるのに役立ちますか?」`)
};

const zh_ci_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它能帮我找出不可见或形似的字符吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ci_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ci_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ci_faq4_q", locale)
	if (locale === "en") return en_ci_faq4_q(inputs)
	if (locale === "es") return es_ci_faq4_q(inputs)
	if (locale === "de") return de_ci_faq4_q(inputs)
	if (locale === "nl") return nl_ci_faq4_q(inputs)
	if (locale === "fr") return fr_ci_faq4_q(inputs)
	if (locale === "it") return it_ci_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_ci_faq4_q(inputs)
	if (locale === "pt") return pt_ci_faq4_q(inputs)
	if (locale === "ja") return ja_ci_faq4_q(inputs)
	return zh_ci_faq4_q(inputs)
};